module.exports = "/img/_/_/_/assets/images/icon//diamond.png?ef4ef248006422f1066dd78512cf3df4";